'use client';

import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import { Card, CardContent, CardHeader } from '@bells/ui/components/card';

export const GirlInterview = ({
  data,
}: {
  data?: AttendantSearchSingleResponse;
}) => {
  return (
    data &&
    data.interviews &&
    data.interviews.length > 0 && (
      <Card className='m-0 w-full border-0 bg-transparent p-0 shadow-none'>
        <CardContent className='flex w-full flex-col space-y-4 p-0'>
          {data.interviews.map((df, index) => {
            return (
              <Card
                key={`question-${index}`}
                className='m-0 w-full border-0 bg-transparent p-0 shadow-none'
              >
                <CardHeader className='px-0 pt-0'>
                  <h3 className='font-semibold leading-none tracking-tight'>
                    {df.question.question}
                  </h3>
                </CardHeader>
                <CardContent className='flex w-full flex-col space-y-4 px-0 text-muted-foreground'>
                  {df.answer}
                </CardContent>
              </Card>
            );
          })}
        </CardContent>
      </Card>
    )
  );
};
